import React from 'react'
import BackgroundSideNav from './BackgroundSideNav'
import LinkMedia from './LinkMedia'

function Background() {
  const sideNav={
    padding: "10px 15px 0",
    height: "100%",
    boxSizing: "border-box"
  }
  return (
    <div className='flex w-[280px]'>
    <div style={{ flex: '1 1 280px', textAlign:'left' }}>
      <div style={sideNav}>
  <BackgroundSideNav />
  </div>
  </div>
 
  </div>
  )
}

export default Background